import {createReducer} from '@reduxjs/toolkit';

import {
  SETTINGS_KEY,
  areaUnits,
  coordinateSystems as coordinates,
  distanceUnits,
  measurementSystems,
  preferenceGroups,
} from '../constants/index.js';
import {get as getStored} from '../util/store.js';

import {setPreference} from '../actions/settings.js';

const initialState = {
  [preferenceGroups.measurementSystem]: measurementSystems.metric,
  [preferenceGroups.coordinateSystem]: coordinates.dd,
  [preferenceGroups.distanceUnitsMetric]: distanceUnits.metric.km,
  [preferenceGroups.areaUnitsMetric]: areaUnits.metric.km2,
  [preferenceGroups.distanceUnitsUSC]: distanceUnits.usc.mi,
  [preferenceGroups.areaUnitsUSC]: areaUnits.usc.mi2,
};

const storedState = getStored(SETTINGS_KEY);

const settings = createReducer({...initialState, ...storedState}, builder => {
  builder.addCase(setPreference, (state, {payload}) => {
    if (!payload) {
      return state;
    }

    // Check if its a valid key
    const isKey = preferenceGroups[payload.key];

    // Check for valid coordinate system value
    const isCoord = Object.keys(coordinates).filter(
      value => coordinates[value] === payload.value
    ).length;

    // Check for valid measurement system value
    const isMeasurementSystem = Object.keys(measurementSystems).filter(
      value => measurementSystems[value] === payload.value
    ).length;

    // Check for valid distance units
    const systemDistanceUnits =
      state.measurementSystem === measurementSystems.metric
        ? distanceUnits.metric
        : distanceUnits.usc;

    const isValidDistanceUnit = Object.keys(systemDistanceUnits).filter(
      value => systemDistanceUnits[value] === payload.value
    ).length;

    // Check for valid area units
    const systemAreaUnits =
      state.measurementSystem === measurementSystems.metric
        ? areaUnits.metric
        : areaUnits.usc;

    const isValidAreaUnit = Object.keys(systemAreaUnits).filter(
      value => systemAreaUnits[value] === payload.value
    ).length;

    // Final check for valid values
    const isValue =
      isCoord || isMeasurementSystem || isValidDistanceUnit || isValidAreaUnit;

    // Set the state if the key value pair is valid
    if (isKey && isValue) {
      state[payload.key] = payload.value;
    }

    return state;
  });
});

export default settings;
